import React, { useState } from 'react'
import './list.scss'
import CustomMarkdown from '../../utils/customMarkdown'
//import 'uikit/dist/css/uikit.css'


const ProductsList = ({ contents }) => {

    // const [title, setTitle] = useState(null);
    // const [prevTitle, setPrevTitle] = useState(null);


    // const updateTitle = (newTitle) => {
    //     if (newTitle !== "EMPTY" && newTitle !== prevTitle) {
    //         setTitle(newTitle);
    //         setPrevTitle(newTitle);
    //         return newTitle;
    //     }
    //     return null;
    // };

    return (
        <div style={{ minHeight: "500px" }}>
            <div className="list-container uk-animation-fade">
                {
                    contents?.map((item, index) => {
                        return (
                            <div>
                                {
                                    item.GroupTitle == "EMPTY" ? 
                                        <div className="padding-top-bottom">
                                            <b style={{ display: "block", width: "1px", marginBottom: "20px" }} /> 
                                        </div>
                                    : item.GroupTitle !== null && item.GroupTitle !== "" ? 
                                            <div className="padding-top-bottom">
                                                <h2 className="group-title">{item.GroupTitle}</h2> 
                                            </div>
                                        : ""
                                }

                                {
                                    item.Products.map((product) => {
                                        return(
                                        <div className="padding-top-bottom">
                                            <div className="list-content">
                                                <p className="product-title">{product.Title}
                                                    {/* {item.Products.Vegan ? <b> (VG)</b> : ""}
                                                    {item.Products.Vegetarian ? <b> (V)</b> : ""}
                                                    {item.Products.Nuts ? <b> (N)</b> : ""}
                                                    {item.Products.Spicy ? <b> (S)</b> : ""} */}
                                                </p>
                                                <p className="product-price">{product.Price}</p>
                                            </div>
                                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                <CustomMarkdown className="product-description">{product.Description}</CustomMarkdown>
                                                {product.Vegan ? <b> (VG)</b> : ""}
                                                {product.Vegetarian ? <b> (V)</b> : ""}
                                                {product.Nuts ? <b> (N)</b> : ""}
                                                {product.Spicy ? <b> (S)</b> : ""}
                                            </div>
                                        </div>
                                        )
                                    })                                   

                                }

                            </div>                          
                        )

                    })
                }
            </div>

        </div>
    )
}

export default ProductsList